/**
 * Display a stored phone number. The backend normalizes phones to E.164 (e.g. +17812961054);
 * legacy rows may still hold free-form text like "+1-(781)296-1054".
 * North American numbers render as (781) 296-1054; other countries keep their +code digits.
 */
export const formatPhoneNumber = (n: string | number): string => {
  const raw = String(n).trim();
  const lower = raw.toLowerCase();

  let main = raw;
  let extension: string | null = null;
  const extMatch = lower.match(/^(.*?)(ext\.?|x)\s*(\d+)\s*$/);
  if (extMatch) {
    main = raw.slice(0, extMatch[1].length).trim();
    extension = `${extMatch[2].startsWith("ext") ? "ext" : "x"} ${extMatch[3]}`;
  }

  const digits = main.replace(/\D/g, "");
  const international = main.startsWith("+");
  const national =
    digits.length === 11 && digits.startsWith("1")
      ? digits.slice(1)
      : digits.length === 10 && !international
        ? digits
        : null;

  const formatted = national
    ? `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
    : international && digits
      ? `+${digits}`
      : main;

  return extension ? `${formatted} ${extension}` : formatted;
};
